module.exports = __webpack_public_path__ + "media/images/details__prizeBox__stretch__third-282e2b5a1feffd7347b7c269ed74852b.png";